import {Component, OnInit} from '@angular/core';
import {switchMap} from 'rxjs/operators';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {TransportationService} from '../../api/transportation.service';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-segment-products',
  templateUrl: './segment-products.component.html',
  styleUrls: ['./segment-products.component.scss']
})
export class SegmentProductsComponent implements OnInit {

  constructor(private transportationService: TransportationService,
              private router: Router,
              private route: ActivatedRoute) {
  }



  zone$: Observable<any>;
  transport$: Observable<any>;
  currentItem: number;
  imageToBeChanged: string;


  ngOnInit() {
    this.zone$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.transportationService.getProducts(params.get('transport'), params.get('zone')))
    );

    this.transport$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.transportationService.getTransportation(params.get('transport')))
    );

    this.zone$.subscribe(res => this.imageToBeChanged = res.image);

  }


  enteringZone(key: string) {
    console.log('key', key);
    this.imageToBeChanged = key;

  }


}


